import { render, staticRenderFns } from "./BackgroundProperty.vue?vue&type=template&id=2bd42426&"
import script from "./BackgroundProperty.vue?vue&type=script&lang=js&"
export * from "./BackgroundProperty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports